import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import { type NavigateOptions, NavLink, type NavLinkProps, type To, useLocation, useNavigate } from 'react-router';

import { useFeatureParamsLocation } from '#hooks/shared/useFeatureParamsLocation.ts';

type AppNavLinkProps = NavLinkProps & {
    trackingKey?: string;
};

/**
 * A custom NavLink component that appends the current search parameters to the `to` prop.
 * This is useful for maintaining query parameters when navigating between routes.
 */
export const AppNavLink = ({ trackingKey, to, ...props }: AppNavLinkProps) => {
    const location = useFeatureParamsLocation();
    const trackingAttributes = trackingKey
        ? getTrackingAttributes({
              trigger: 'click',
              category: 'link autoTracking',
              action: 'link click',
              label: trackingKey,
          })
        : {};

    return <NavLink {...props} {...trackingAttributes} to={to + location} />;
};

export const useAppNavigate = () => {
    const location = useLocation();
    const nav = useNavigate();
    return (to: To, options?: NavigateOptions) =>
        options ? nav(to + location.search, options) : nav(to + location.search);
};
